// Column template shared by the side-by-side semester tables (grades, attestations, picked disciplines,
// credits) so their columns always line up.
//
// At most two columns, each at least `minColumnWidth` px: when two such columns don't fit, the grid drops
// to one full-width column and the second table wraps onto a new row - no horizontal scroll.
// auto-fill (not auto-fit) keeps the column positions even when a grid holds a single table.
export const GRADES_TABLE_MIN_WIDTH = 600;
export const ATTESTATIONS_TABLE_MIN_WIDTH = 400;
// 2rem, not 1rem: the framed boxes cast a shadow to the right, so 1rem looked cramped - e.g. between
// „Избираеми“ and „Факултативни дисциплини“. Shared by all these grids so their columns stay aligned.
export const SEMESTER_GRID_GAP = "2rem";

export const semesterGridColumns = (isMobile, minColumnWidth = GRADES_TABLE_MIN_WIDTH) =>
  isMobile
    ? "minmax(0, 1fr)"
    : `repeat(auto-fill, minmax(max(min(100%, ${minColumnWidth}px), calc((100% - ${SEMESTER_GRID_GAP}) / 2)), 1fr))`;
